import { LoggerLevel } from 'types';

const environmentConfig = {
  environment: 'prod',
  applicationId: 'prod-react-header-footer',
  api: {
    homr: 'https://www.dickssportinggoods.com/dcsg-ngx-home/homr/v2/api/v4/content',
    sayt: {
      dsg: { baseUrl: 'https://prod-catalog-autosuggest-api.dickssportinggoods.com/' },
      gg: { baseUrl: 'https://prod-catalog-autosuggest-api.dickssportinggoods.com/' },
      pl: { baseUrl: 'https://prod-catalog-autosuggest-api.dickssportinggoods.com/' },
      mj: { baseUrl: 'https://prod-catalog-autosuggest-api.dickssportinggoods.com/' },
      g3: { baseUrl: 'https://prod-catalog-autosuggest-api.dickssportinggoods.com/' },
    },
    availability: {
      dsg: {
        baseUrl: 'https://availability.dickssportinggoods.com',
        key: 'sb-2a63f428-1a20-11ec-b434-3b32fc4423a5',
      },
      gg: {
        baseUrl: 'https://availability.dickssportinggoods.com',
        key: 'sb-2a63f428-1a20-11ec-b434-3b32fc4423a5',
      },
      pl: {
        baseUrl: 'https://availability.dickssportinggoods.com',
        key: 'sb-2a63f428-1a20-11ec-b434-3b32fc4423a5',
      },
      mj: {
        baseUrl: 'https://availability.dickssportinggoods.com',
        key: 'sb-2a63f428-1a20-11ec-b434-3b32fc4423a5',
      },
      g3: {
        baseUrl: 'https://availability.dickssportinggoods.com',
        key: 'sb-2a63f428-1a20-11ec-b434-3b32fc4423a5',
      },
    },
    microService: {
      logger: {
        path: '/spring/msvc/logger/publish',
        host: {
          dsg: {
            baseUrl: 'https://www.dickssportinggoods.com',
          },
          gg: {
            baseUrl: 'https://www.golfgalaxy.com',
          },
          pl: {
            baseUrl: 'https://www.publiclands.com',
          },
          mj: {
            baseUrl: 'https://www.moosejaw.com',
          },
          g3: {
            baseUrl: 'https://www.goinggoinggone.com',
          },
        },
      },
    },
    logger: {
      client: {
        level: LoggerLevel.LOG,
      },
      xhr: {
        level: LoggerLevel.LOG, // DO NOT TOUCH
        url: 'https://prod-log-publisher.iso.ap01.pcf.dcsg.com/publish', // same as deploy domain in build.yml
      },
    },
    promotionData: {
      dsg: {
        baseUrl: 'https://gateway.dcsg.com/ws/WCS/v2/api/promotiondescription',
        key: 'c0fcfbe0-9983-11e7-b506-c779759784e8',
        headerEnvValue: 'prdlive',
      },
      gg: {
        baseUrl: 'https://gateway.dcsg.com/ws/WCS/v2/api/promotiondescription',
        key: 'c0fcfbe0-9983-11e7-b506-c779759784e8',
        headerEnvValue: 'prdlive',
      },
      pl: {
        baseUrl: 'https://gateway.dcsg.com/ws/WCS/v2/api/promotiondescription',
        key: 'c0fcfbe0-9983-11e7-b506-c779759784e8',
        headerEnvValue: 'prdlive',
      },
      mj: {
        baseUrl: 'https://gateway.dcsg.com/ws/WCS/v2/api/promotiondescription',
        key: 'c0fcfbe0-9983-11e7-b506-c779759784e8',
        headerEnvValue: 'prdlive',
      },
      g3: {
        baseUrl: 'https://gateway.dcsg.com/ws/WCS/v2/api/promotiondescription',
        key: 'c0fcfbe0-9983-11e7-b506-c779759784e8',
        headerEnvValue: 'prdlive',
      },
    },
  },
};

export default environmentConfig;
